export const SWAG_BUNDLE_ERRORS_ACTIONS = {
  BUNDLE_IN_ACTIVITIES_TEXT: 'This box is currently part of an active giveaway or distribution. Please try again once the giveaway or distribution is complete.'
};
export const SWAG_BUNDLE_SUCCESS_ACTIONS = {
  BUNDLE_UPDATED: 'Swag bundle was successfully updated.'
};